import cx from 'classnames';

import { ReactComponent as ArrowBack } from 'assets/icons/ArrowBack.svg';

import Button from '../../../Button/Button';

interface MonthChangeButtonProps {
  onClick: () => void;
  isIncrease?: boolean;
}

const MonthChangeButton = ({ onClick, isIncrease }: MonthChangeButtonProps) => (
  <Button variant="ghost" size="neutral" className="h-fit rounded-xl border-none !p-1.5 group" onClick={onClick}>
    <ArrowBack
      className={cx('stroke-1.5 h-5 w-5 stroke-black group-hover:stroke-primary-50', { 'rotate-180': isIncrease })}
    />
  </Button>
);

export default MonthChangeButton;
